export default __webpack_public_path__ + "1.17.16/static/media/LibreDataSharecode_Japanese.30f658c9.svg";